var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-plain-textarea.ts
import "@adornis/ass/style.js";
import { injectAttributesOf } from "@adornis/chemistry/directives/inject-attributes.js";
import { FormField } from "@adornis/formfield/form-field.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { property } from "lit/decorators/property.js";
import { live } from "lit/directives/live.js";
import { ref } from "lit/directives/ref.js";
import { fromEvent, takeUntil } from "rxjs";
var XPlainTextarea = class extends FormField {
  constructor() {
    super(...arguments);
    this["enter-submits"] = false;
    this["no-auto-resize"] = false;
  }
  styles() {
    return [
      {
        ":host": { display: "block" },
        textarea: {
          height: "100%",
          outline: "none",
          width: "100%",
          background: "var(--background, transparent)",
          textAlign: "inherit",
          border: "none",
          margin: "0",
          padding: "0",
          color: "inherit",
          fontWeight: "inherit",
          fontSize: "inherit",
          fontFamily: "inherit",
          resize: "none",
          "&::placeholder": {
            color: this.colors.tone.placeholder
          }
        }
      }
    ];
  }
  connectedCallback() {
    super.connectedCallback();
    fromEvent(this, "click").pipe(takeUntil(this.disconnected)).subscribe(() => this._area?.focus());
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    const textarea = this.shadowRoot?.querySelector("textarea");
    if (!textarea)
      return;
    textarea.style.height = textarea.scrollHeight + "px";
    requestAnimationFrame(() => {
      textarea.style.height = textarea.scrollHeight === 0 ? "1.2em" : textarea.scrollHeight + "px";
    });
  }
  render() {
    return html`
      <textarea
        @input=${(e) => {
      const area = e.currentTarget;
      this.value.next(area.value);
      if (this["no-auto-resize"])
        return;
      area.style.height = "auto";
      area.style.height = area.scrollHeight + "px";
    }}
        @search="${(e) => this.value.next(e.currentTarget.value)}"
        @keydown="${(e) => {
      if (e.key === "Enter") {
        const shift = e.getModifierState("Shift");
        const ctrl = e.getModifierState("Control");
        if (this["enter-submits"] && !shift || !this["enter-submits"] && ctrl) {
          e.preventDefault();
          this.dispatchEvent(
            new CustomEvent("submit", {
              detail: { value: e.currentTarget.value },
              composed: true,
              bubbles: true
            })
          );
        }
      }
      if (e.key === "Escape")
        return this.dispatchEvent(new CustomEvent("escape"));
    }}"
        @blur=${(e) => {
      this.value.next(e.currentTarget.value);
      this.dispatchEvent(new CustomEvent("value-picked", { detail: { value: this.value.value } }));
    }}
        .value=${live(this.value.value ?? "")}
        ?disabled=${this.disabled}
        ${injectAttributesOf(this)}
        ${ref((e) => this._area = e)}
      ></textarea>
    `;
  }
};
__decorateClass([
  property({ type: Boolean })
], XPlainTextarea.prototype, "enter-submits", 2);
__decorateClass([
  property({ type: Boolean })
], XPlainTextarea.prototype, "no-auto-resize", 2);
XPlainTextarea = __decorateClass([
  customElement("x-plain-textarea")
], XPlainTextarea);
export {
  XPlainTextarea
};
